function injectStylesToShadowRoot() {
  const host = document.querySelector('.sovrn-commerce-ai-shopping-gallery');

  if (host && host.shadowRoot) {
    // Check if styles already injected
    if (!host.shadowRoot.querySelector('style.injected-by-script')) {
      const style = document.createElement('style');
      style.classList.add('injected-by-script');
      style.textContent = `
        .sovrn-commerce-ai-shopping-gallery-root {
          max-width: var(--page-width);
          margin: 0 auto;
          padding: 0 1.5rem;
        }

        .sovrn-commerce-ai-shopping-gallery-root > div {
          width: 100%;
          max-width: 1260px;
        }

        .sovrn-commerce-ai-shopping-gallery-root .product-card-container,
				.sovrn-commerce-ai-shopping-gallery-root [data-testid="product-skeleton-container"] {
          box-sizing: border-box;
          width: 100%;
					max-width: 100%;
        }

        @media (min-width: 750px) {
          .sovrn-commerce-ai-shopping-gallery-root {
            padding: 0 5rem;
          }
        }
      `;

      host.shadowRoot.appendChild(style);
    }
    return true;
  }
  return false;
}

// Poll every 300ms until the shadow root and element are ready or timeout after 10 seconds
let attempts = 0;
const maxAttempts = 33;

const intervalId = setInterval(() => {
  attempts++;
  if (injectStylesToShadowRoot() || attempts > maxAttempts) {
    clearInterval(intervalId);
  }
}, 300);


const DesktopMenuHoverableDropdown = () => {
  const dropdownMenus = document.querySelectorAll('details.mega-menu');

  if (dropdownMenus.length === 0) return;

  dropdownMenus.forEach(dropdown => {
    let timeoutId;

    dropdown.addEventListener('mouseenter', () => {
      clearTimeout(timeoutId);
      dropdown.setAttribute('open', '');
    });

    dropdown.addEventListener('mouseleave', (e) => {
      timeoutId = setTimeout(() => {
        dropdown.removeAttribute('open');
      }, 500); // shorter feels snappier
    });
  });
};

window.addEventListener('DOMContentLoaded', DesktopMenuHoverableDropdown);

